<div class="settings-container settings-container--integration">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    @if (isConversationalAnalyticsIntegrationActive) {
      <li [ngbNavItem]="1">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::ConversationalAnalytics' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <app-conversational-analytics-settings
            [hasActiveSync]="conversationalAnalyticsHasActiveSync">
          </app-conversational-analytics-settings>
        </ng-template>
      </li>
    }
    @if (isVirtualAgentIntegrationActive) {
      <li [ngbNavItem]="2">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::VirtualAgent' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <app-virtual-agent-settings [hasActiveSync]="virtualAgentHasActiveSync">
          </app-virtual-agent-settings>
        </ng-template>
      </li>
    }
    <li [ngbNavItem]="3">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::CallRecording' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <app-call-recording-settings></app-call-recording-settings>
      </ng-template>
    </li>
    <li [ngbNavItem]="4">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::AnsweringMachineDetection' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <app-answering-machine-detection-settings></app-answering-machine-detection-settings>
      </ng-template>
    </li>
  </ul>
  @if (hasActiveSyncBanner) {
    <app-info-banner
      class="mb-3"
      mode="warning"
      [description]="'Settings::ActiveSyncInProgress' | abpLocalization">
    </app-info-banner>
  }
  <div [ngbNavOutlet]="nav"></div>
</div>
